module.exports = {
      id: "thump-usage",
      viewBox: "0 0 58 75",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#thump",
      toString: function () {
        return this.url;
      }
    }